import type { ErrorFrame } from '../../ports/ErrorFrame';

/**
 * Player-safe copy for an error frame, chosen by its machine-readable code.
 * An error frame's `message`/`detail` are system diagnostics and are never
 * shown to the player; they go to the console instead (see ExperienceSession).
 */
const LOCATION_NEEDED = 'Share your location so the adventure can begin.';
const NOTHING_NEARBY = 'Nothing nearby is ready to start yet. Head toward the starting point and try again.';
const NOT_READY = "Things aren't quite ready yet. Try again in a moment.";
const LINE_WENT_QUIET = 'The line went quiet for a moment. Try again.';

const COPY_BY_CODE: Record<string, string> = {
  bootstrap_location_required: LOCATION_NEEDED,
  location_required: LOCATION_NEEDED,
  bootstrap_no_nearby_route: NOTHING_NEARBY,
  no_nearby_route: NOTHING_NEARBY,
};

export function playerErrorText(frame: ErrorFrame): string {
  const code = typeof frame.code === 'string' ? frame.code : '';
  if (COPY_BY_CODE[code]) return COPY_BY_CODE[code];
  if (code.startsWith('bootstrap_') || code === 'missing_client_bootstrap') return NOT_READY;
  return LINE_WENT_QUIET;
}
